export const DEFAULT_CONTENT = {
  BADPARAMS: '您所填寫的[TYPE]有誤，請確認後重新填寫送出。',
  DEFAULT: '內部伺服器出現問題，請通知Home心客服，做進一步確認。',
};

export const DEFAULT_TITLE = {
  FORM: '哎呀!<br />您所填的資料有錯誤!',
  BADPARAMS: '哎呀!<br />您所填的資料有錯誤',
  DUPLICATE: '哎呀!<br />您所填的資料有重複!',
  NOTFOUND: '哎呀!<br />不存在!',
  REGISTRATION: '哎呀!<br />註冊過程中發生錯誤!',
  BADSTATE: '哎呀!<br />您的狀態不允許此操作!',
  NOTUPDATED: '小提醒',
  INVALID_SIGNATURE: '哎呀!<br />資料更動!',
  DEFAULT: '內部問題',
};
